/*=========================================================================================
  File Name: module-usertax-actions.js
  Description: UserTax Module Actions
  ----------------------------------------------------------------------------------------
  Project: MISA MTAX WebApp
  Author: MISA JSC
  Author URL: http://www.misa.com.vn
==========================================================================================*/
import httpClient from '../../api/axios-httpclient';
import commonFunc from '@/common/commonFunction';
import InternalAPI from '@/api/InternalAPI.js';

export default {
	getInvoicesById: async function(context, payload) {
		let res = await httpClient.getAsync({
			url: InternalAPI.getAPIUrl() + `/invoice/${payload.SubscriberId}/${payload.InvoiceId}`,
			data: payload
		});
		if (res) {
			return res;
		}
		return null;
	},

	getOutInvoicesById: async function(context, payload) {
		let res = await httpClient.getAsync({
			url: InternalAPI.getAPIUrl() + `/outinvoice/${payload.SubscriberId}/${payload.InvoiceId}`
		});
		if (res) {
			return res;
		}
		return null;
	},

	/**
	 * Lấy key kiểm tra lệnh thực thi tool đã chạy hay chưa
	 */
	getCheckRunningToolAsync: async function(context, payload) {
		let res = await httpClient.getAsync({
			url: InternalAPI.getAPIUrl() + `/checkrunning/${payload}`
		});
		if (res) {
			return res;
		}
		return null;
	},

	/**
	 * Hàm lấy video hướng dẫn tạo email
	 * @param {*} context
	 * @param {*} payload
	 * @returns
	 */
	getVideoCreatedEmail: async function(context, payload) {
		let res = await httpClient.getAsync(
			{
				url: InternalAPI.getAPIUrl() + `/getvideocreateemail`
			},
			false
		);
		if (res && res.Data) {
			return res.Data;
		}
		return null;
	}
};
